import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { openAlert } from '../../store/actions/alert';
import { CommonProperties, Color, CommonStyles } from '../../styles';
import Button from '../Button';
import BaseText from '../BaseText';
import SearchTypeCheckbox from './SearchTypeCheckbox';
import SearchSubTypePickerRebook from './SearchSubTypePickerRebook';
import SearchDateDisplay from './SearchDateDisplay';
import SearchArrivalCityDisplay from './SearchArrivalCityDisplay';
import SearchDepartureCityDisplay from './SearchDepartureCityDisplay';
import SearchTripOptionsDisplay from './SearchTripOptionsDisplay';
import { Modals } from '../../constants/ScreenNames';
import { selectGeolocation } from '../../store/selectors/trip.selector';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import useTripSearchWidget from '../../utils/useTripSearchWidget';
import { selectCheckedRebookPassengers } from '../../store/selectors/mytrips.selector';
const TripSearchFormFields = ({ criteria, searchInputState, index, showPicker, dispatch }) => {
  const { t } = useTranslation(i18nNS.searchWidget);
  const { tKey } = useComponentTKey('TripSearchWidget');
  const geolocation = useSelector(selectGeolocation);
  const route = useRoute();
  const navigation = useNavigation();
  const {
    hasAir,
    hasHotel,
    hasCar,
    hasRail,
    subSearchType,
    dominantSearchType,
    airClassType,
    searchCriteria,
    enableSearchTypeSelector,
    enablePassengerClass,
  } = searchInputState;
  const hideDeparture = dominantSearchType === 'car';

  const hideArrival = dominantSearchType === 'car' && subSearchType === 'oneway';

  if (subSearchType !== 'multicity' && index !== 0) {
    return null;
  }
  const isLast = searchCriteria.length - 1 === index;
  return (
    <>
      <View style={styles.widgetContainer}>
        {showPicker && enableSearchTypeSelector && !!dominantSearchType && (
          <SearchSubTypePickerRebook
            dominantSearchType={dominantSearchType}
            subSearchType={subSearchType}
            rowBtnStyle={styles.rowButton}
            onSelection={() => {
              console.log('no action');
            }}
          />
        )}
        {!hideDeparture && (
          <TouchableOpacity
            style={styles.rowButton}
            onPress={() =>
              navigation.navigate(Modals.StationAutoCompleteModal, {
                returnScreen: route.name,
                source: 'from',
                index,
                hasAir,
                hasHotel,
                hasCar,
                hasRail,
                subSearchType,
              })
            }
          >
            <SearchDepartureCityDisplay
              fromCity={criteria.fromCity}
              subSearchType={subSearchType}
              departureAirport={criteria.departureAirport}
              geolocation={geolocation}
              dominantSearchType={dominantSearchType}
            />
          </TouchableOpacity>
        )}
        {!hideArrival && (
          <TouchableOpacity
            style={styles.rowButton}
            onPress={() =>
              navigation.navigate(Modals.StationAutoCompleteModal, {
                returnScreen: route.name,
                source: 'to',
                index,
                hasAir,
                hasHotel,
                hasCar,
                hasRail,
                subSearchType,
              })
            }
          >
            <SearchArrivalCityDisplay
              toCity={criteria.toCity}
              subSearchType={subSearchType}
              arrivalAirport={criteria.arrivalAirport}
              dominantSearchType={dominantSearchType}
              geolocation={geolocation}
            />
          </TouchableOpacity>
        )}
        <TouchableOpacity
          style={styles.rowButton}
          onPress={() =>
            navigation.navigate(Modals.Calendar, {
              returnScreen: route.name,
              index,
              minDate:
                index === 0
                  ? null
                  : searchCriteria[index - 1].toDate
                  ? searchCriteria[index - 1].toDate
                  : searchCriteria[index - 1].fromDate,
              //allowRange: hasHotel || hasCar || subSearchType === 'roundtrip',
              allowRange: !(
                (dominantSearchType === 'air' || dominantSearchType === 'rail') &&
                ((subSearchType === 'oneway' && !(hasHotel || hasCar)) ||
                  subSearchType === 'multicity')
              ),
              showCarTimePickers: hasCar && !hasAir,
              fromDate: criteria.fromDate,
              toDate: criteria.toDate,
              dropOffTime: criteria.carDropOffTime,
              pickUpTime: criteria.carPickUpTime,
            })
          }
        >
          <SearchDateDisplay
            fromDate={criteria.fromDate}
            toDate={criteria.toDate}
            subSearchType={subSearchType}
            dominantSearchType={dominantSearchType}
            hasCar={hasCar}
            hasHotel={hasHotel}
          />
        </TouchableOpacity>
        {subSearchType !== 'multicity' && enablePassengerClass && (
          <TouchableOpacity
            disabled={!hasAir} //only enabled for air until we allow selecting traveler/room/car #
            onPress={() => {
              navigation.navigate(Modals.SearchTripOptionsModal, {
                returnScreen: route.name,
                currentAirClass: searchInputState.airClassType,
                //the next lines need to be fixed when selecting traveler/room/car # is available
                hasAir: false,
                hasCar: false,
                hasHotel: false,
                tripOptions: {
                  noOfCars: 1,
                  noOfRooms: 1,
                  persons: {
                    noOfAdults: 1,
                    noOfSeniors: 0,
                    infants: [],
                  },
                },
                // until this line
              });
            }}
          >
            <SearchTripOptionsDisplay
              dominantSearchType={dominantSearchType}
              hasHotel={hasHotel}
              hasCar={hasCar}
              airClassType={airClassType}
              tripOptions={{
                noOfCars: 1,
                noOfRooms: 1,
                persons: {
                  noOfAdults: 1,
                  noOfSeniors: 0,
                  infants: [], // => array of {age: numerical,inSeat: boolean}
                },
              }}
            />
          </TouchableOpacity>
        )}
      </View>
    </>
  );
};

export const TripSearchForm = ({ dispatch, searchInputState }) => {
  const { searchCriteria } = searchInputState;
  return (
    <>
      {searchCriteria.map((criteria, index) => (
        <TripSearchFormFields
          key={index}
          index={index}
          showPicker={index === 0}
          criteria={criteria}
          dispatch={dispatch}
          searchInputState={searchInputState}
        />
      ))}
    </>
  );
};

const TripSearchWidgetRebook = (props) => {
  const { t } = useTranslation(i18nNS.searchWidget);
  const { tKey } = useComponentTKey('TripSearchWidget');
  const [
    { searchInputState, isNearbyHotelTonightSearch, handleSearchTypeChecked, onSubmit },
    dispatch,
  ] = useTripSearchWidget(props.allowRehydration, props.onSearch, '', props.isRebook);
  const reduxDispatch = useDispatch();
  const checkedRebookPassengers = useSelector(selectCheckedRebookPassengers);
  const checkedRebookPassengerCount = checkedRebookPassengers?.length === 0;
  const { hasAir, hasHotel, hasCar, hasRail } = searchInputState;
  return (
    <View style={CommonStyles.px3}>
      <View style={styles.searchTypeRowWrap}>
        <View style={styles.searchTypeRow}>
          <SearchTypeCheckbox
            selected={true}
            disabled={true}
            iconName="flight"
            onPress={() => handleSearchTypeChecked('air')}
          />
        </View>
      </View>
      <TripSearchForm dispatch={dispatch} searchInputState={searchInputState} />
      <View>
        <Button
          style={styles.submitButton}
          label={
            isNearbyHotelTonightSearch() ? t(tKey('SearchNearbyHotelsTonight')) : t('common:Search')
          }
          labelStyle={isNearbyHotelTonightSearch() ? styles.nearbyHotel : CommonStyles.h2}
          loading={props.loading}
          onPress={() => {
            if (checkedRebookPassengerCount) {
              reduxDispatch(
                openAlert({
                  title: 'No Passenger Selected',
                  message: 'Please select atleast one passenger.',
                  confirmText: t('common:Okay'),
                })
              );
            } else {
              onSubmit();
            }
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  submitButton: {
    ...CommonProperties.py3,
    ...CommonProperties.shadow,
    ...CommonProperties.borderRadius4,
  },
  widgetContainer: {
    backgroundColor: Color.accent,
    ...CommonProperties.mt2,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
  },
  searchTypeRow: {
    height: scale(52),
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: Color.accent,
    overflow: 'hidden',
    ...CommonProperties.borderRadius,
  },
  searchTypeRowWrap: {
    ...CommonProperties.mt2,
    ...CommonProperties.mb3,
    ...CommonProperties.borderRadius,
    ...CommonProperties.shadow,
  },
  rowButton: {
    borderBottomWidth: 0.7,
    borderColor: 'rgba(0,0,0,.2)',
    ...CommonProperties.p3,
  },
  addCityButton: {
    ...CommonProperties.my1,
    ...CommonProperties.p1,
    ...CommonProperties.centerAlignment,
    flexDirection: 'row',
  },
  addCityButtonText: {
    color: Color.primary,
  },
  nearbyHotel: {
    ...CommonProperties.h4,
    ...CommonProperties.my2,
  },
});

export default TripSearchWidgetRebook;
